@if (listo()) {
  <div class="gateway-page">
    <div class="gateway-background" aria-hidden="true"></div>
    <div class="gateway-overlay" aria-hidden="true"></div>
    <div class="gateway-vignette" aria-hidden="true"></div>
    <div class="gateway-decoration gateway-decoration--top-left" aria-hidden="true"></div>
    <div class="gateway-decoration gateway-decoration--bottom-left" aria-hidden="true"></div>

    <div class="gateway-content">
      <header class="gw-header">
        <div class="gw-brand">
          <app-jamar-logo [ancho]="150" [alto]="32" />
          <div class="gw-fair-title">PORTAL DE INGRESO</div>
        </div>
      </header>

      <main class="gw-hero">
        <p class="gw-eyebrow"><span class="gw-eyebrow-bar" aria-hidden="true"></span>BIENVENIDO</p>
        <h1 class="gw-h1">¿A qué módulo quieres <span class="gw-h1-accent">ingresar?</span></h1>
        <p class="gw-desc">Selecciona una opción para acceder a la plataforma según tus necesidades.</p>

        <div class="module-grid">
          @for (m of modulos; track m.id) {
            <a
              role="link"
              tabindex="0"
              class="module-card"
              [class.module-card--feria]="m.id === 'feria'"
              [class.module-card--calidad]="m.id === 'calidad'"
              [attr.aria-label]="'Entrar al módulo ' + m.titulo"
              (click)="entrar(m)"
              (keydown.enter)="entrar(m)"
            >
              <div class="module-card-icon" aria-hidden="true">
                @if (m.id === 'feria') {
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l1.5-5h15L21 9" />
                    <path d="M3 9h18v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9Z" />
                    <path d="M9 20v-6h6v6" />
                  </svg>
                } @else {
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2 4 5v6c0 5 3.4 9 8 11 4.6-2 8-6 8-11V5l-8-3Z" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                }
              </div>
              <h2 class="module-card-title">{{ m.titulo }}</h2>
              <p class="module-card-desc">{{ m.descripcion }}</p>
              <span class="module-card-cta" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14" />
                  <path d="m13 6 6 6-6 6" />
                </svg>
              </span>
              <span class="module-card-bar" aria-hidden="true"></span>
            </a>
          }
        </div>
      </main>

      <div class="gw-footer-row">
        <div class="gw-trust">
          <span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 9 8 11 4.6-2 8-6 8-11V5l-8-3Z" /></svg>
            Plataforma segura
          </span>
          <span class="gw-trust-sep" aria-hidden="true"></span>
          <span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17.5 19H9a7 7 0 1 1 1.1-13.9A5.5 5.5 0 0 1 20 9.5c0 .3 0 .6-.1.9A4.5 4.5 0 0 1 17.5 19Z" /></svg>
            Acceso desde cualquier lugar
          </span>
          <span class="gw-trust-sep" aria-hidden="true"></span>
          <span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z" /></svg>
            Jamar · Portal de ingreso
          </span>
        </div>

        <div class="gw-brand-message">
          <div class="gw-brand-message-text">JUNTOS HACIA NUEVOS MERCADOS</div>
          <div class="gw-copyright">© 2026 Jamar. Todos los derechos reservados.</div>
        </div>
      </div>
    </div>
  </div>
}
